// src/components/shared/PageHeader.jsx
import React from 'react';

const PageHeader = ({ 
  title, 
  user, 
  isDarkMode, 
  showUserInfo = true 
}) => {


  return (
    <div className={`fixed top-[70px] left-20 right-0 z-80 h-15 flex items-center justify-between px-8 shadow-sm ${
      isDarkMode ? 'bg-[#1F2023] border-gray-700' : 'bg-white border-gray-200'
    } border-b`}>
      {/* Page Title */}
      <h1 className="text-2xl font-semibold">{title}</h1>

      {/* User Info (optional) */}
      
      
    </div>
  );
};

export default PageHeader;